import "../App.css";
//import "./home.css";
import moment from "moment";
import React, { useState, useEffect } from "react";
import { LoadingPage } from "../loading/LoadingPage";
import { NavigationBar } from "../navigation/NavigationBar";

import { Pagination } from "../paging/Pagination";

import { useParams, Link } from "react-router-dom";
import { call, home } from "../service/ApiService";
import {
  Container,
  List,
  Paper,
  //Grid,
  // Button,
  // AppBar,
  // Toolbar,
  //Typography,
  ListItem,
  ListItemText,
  InputBase,
  Checkbox,
  ListItemSecondaryAction,
  IconButton,
  Button,
} from "@mui/material";

export function AllUser() {
  const [items, setItems] = useState([]);
  const [pages, setPages] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const size = 10;
  let limit = size;

  useEffect(() => {
    //effect 훅 //랜더링 후에 수행 이후  []의 오브젝트가 변경되면 수행
    call("/admin/userList", "POST", "").then((response) => {
      console.log(response);
      if (!response) {
        alert("누구냐 넌 : " + "정체를 밝혀라.");
        window.location.href = "/home";
      }

      if (response.error) {
        alert("누구냐 넌 : " + response.error);
        window.location.href = "/home";
      }

      if (response.data) {
        setItems(response.data);
        setTotalPage(Math.floor((response.data.length - 1) / size) + 1);
      }
    });
  }, []);

  // pays?basket=402880828b0fce5b018b0fcebef80000
  const params = new URLSearchParams(window.location.search);
  let messege = params.get("messege");
  //console.log("basket :" + basket);
  //pays({ basket: basket });

  /* 장애일 때 렌더링 할 부분 */
  //let loadingPage = <h1> admin.. </h1>;
  //let content = todoItems;

  /* 선택한 content 렌더링 */
  //{"welcomt Home!"}

  let home = "Welcome Home!";

  let subject = "관리자 페이지";
  let navigationBar = NavigationBar(subject);

  //<Checkbox checked={item.done} onChange={checkboxEventHandler} />

  let menu = (
    <Paper style={{ margin: 16 }}>
      <List className="menu">
        <div>{"Menu"}</div>
        <ListItem>
          <Link to="/api" variant="1">
            상위단계 api
          </Link>
          <ListItemText></ListItemText>
          <ListItemSecondaryAction>상위 단계로 이동.</ListItemSecondaryAction>
        </ListItem>
      </List>
    </Paper>
  );

  items.map((item) => {
    if (moment(item.createdAt).isValid()) {
      item.createdAt = moment(item.createdAt).format("YYYY-MM-DD");
    } else {
      //item.createdAt = moment().format("YYYY-MM-DD");
      item.createdAt = moment("2000-01-01", "YYYY-MM-DD").format("YYYY-MM-DD");
    }
  });

  let todoItems = items.length > 0 && (
    <div>
      <table>
        <thead></thead>
        <tbody>
          <tr>
            <th>고유번호</th>
            <th>유저아이디</th>
            <th>오스프로바이더</th>
            <th>생성일</th>
          </tr>
          {items.map((item) => (
            <tr item={item} key={item.id}>
              <td>
                {""}
                {item.id}
              </td>
              <td>
                {""}
                {item.username}
              </td>
              <td>
                {""}
                {item.authProvider}
              </td>
              <td>
                {""}
                {item.createdAt}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  let paging = Pagination({ totalPage, limit, pages, setPages });
  if (items.length == 0) {
    paging = <div>없음.</div>;
  }
  /*
  let todoItems = items.length > 0 && (
    <Paper style={{ margin: 16 }}>
      <List>
        {items.map((item) => (
          <div item={item} key={item.id}>
            {item.id}
            {" -- "}
            {item.username}
          </div>
        ))}
      </List>
    </Paper>
  );

  */

  let content;
  /* 로딩중이 아닐 때 렌더링 할 부분 */
  let framePage = (
    <div>
      {navigationBar} {/* 네비게이션 바 렌더링 */}
      <Container maxWidth="md">{menu}</Container>
      <Container maxWidth="md">{todoItems}</Container>
      <Container maxWidth="md">{paging}</Container>
    </div>
  );

  content = framePage;
  return <div className="App">{content}</div>;
}
